var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.CharacterStateEnum = {
  IDLE: 0,
  RUNNING: 1,
  JUMP: 2,
  FALL: 3,
};

EHDI.game.Character = function () {
    EHDI.aka.Container.call(this);
  };

EHDI.game.Character.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Character.prototype.init = function () {
  this._characterStartingX = 230;
  this._characterStartingY = 500;

  this._jumpTime = 0;
  this._jumpDelay = 26;

  this._baseSpeed = 0.2;
  this._currentSpeed;

  this._jumpVelY = -15;
  this._currentVelY;
  this._gravity = 0.7;
  this._newY;
  this._prevY;

  this._dbFactory;
  this._textureImage;
  this._textureData;
  this._skeleton;
  this._armatureDisplay;

  this._animation;

  this._currentState = EHDI.game.CharacterStateEnum.IDLE;

  this._hitbox;

  if (this._hitbox == undefined) {
    this._hitbox = new EHDI.game.Hitbox(30, 30, 120, 0, 0x0000ff);

    this.addChild(this._hitbox);
  }

  if (this._animation == undefined) {
    this._animation = new EHDI.game.Animation();
    this._animation.init('gizmo');

    this._animation.getDisplay().y = -2;

    this.addChild(this._animation.getDisplay());
  }

  this.x = this._characterStartingX;
  this.y = this._characterStartingY;
  this.rotation = 0;
  this._newY = this._characterStartingY;
  this._prevY = this._characterStartingY;
};

EHDI.game.Character.prototype.getHitbox = function () {
  return this._hitbox;
};

EHDI.game.Character.prototype.stateManager = function (newState) {
  if (this.currentState != newState) {
    // console.log(newState);
    if (newState == EHDI.game.CharacterStateEnum.RUNNING)
      this._animation.changeAnimation('run');

    this._currentState = newState;
  }
};

EHDI.game.Character.prototype.start = function () {
  this._currentSpeed = this._baseSpeed;
  this._currentVelY = 0;

  this.stateManager(EHDI.game.CharacterStateEnum.FALL);
};

EHDI.game.Character.prototype.jump = function () {
  if (this._jumpTime >= this._jumpDelay &&
  this._currentState == EHDI.game.CharacterStateEnum.RUNNING) {
    EHDI.GAME.soundManager.playSFX("jump");

    this._currentVelY = this._jumpVelY;

    this._animation.changeAnimation('jump');
    this.stateManager(EHDI.game.CharacterStateEnum.JUMP);

    return true;
  } else {
    return false;
  }
};

EHDI.game.Character.prototype.fall = function (changeAnimation) {
  if (changeAnimation) {
    this._animation.changeAnimation('jump');
  }

  this.stateManager(EHDI.game.CharacterStateEnum.FALL);
  this._currentVelY = 0;
};

EHDI.game.Character.prototype.getSpeed = function () {
  return this._currentSpeed;
};

EHDI.game.Character.prototype.update = function (delta) {
  this._jumpTime += delta;

  if (this._currentState != EHDI.game.CharacterStateEnum.IDLE &&
  this._currentState != EHDI.game.CharacterStateEnum.RUNNING) {
    this._currentVelY += this._gravity;

    if (this._currentState == EHDI.game.CharacterStateEnum.JUMP &&
    this._currentVelY > 0) {
      this.fall(true);
    }

    this._prevY = this._newY;
    this._newY = this.y + this._currentVelY;
    this._hitbox.update(this.x, this._newY);
  }
};

EHDI.game.Character.prototype.updatePos = function () {
  if (this.y != this.newY) {
    this.y = this._newY;
  }
};

EHDI.game.Character.prototype.collidedWithAPlatform = function (newY) {
  this._jumpTime = 0;

  this._prevY = this._newY;
  this._newY = newY;
  this._hitbox.update(this.x, this._newY);

  this.stateManager(EHDI.game.CharacterStateEnum.RUNNING);
};

EHDI.game.Character.prototype.updateYPos = function (newY) {
  this._newY = newY;
}

EHDI.game.Character.prototype.moveXPos = function (speed) {
  this.x += speed;
  this._hitbox.update(this.x, this._newY);
}

EHDI.game.Character.prototype.getPrevY = function () {
  return this._prevY;
};

EHDI.game.Character.prototype.getCharacterState = function () {
  return this._currentState;
};

EHDI.game.Character.prototype.getJumpVelY = function () {
  return this._jumpVelY;
};

EHDI.game.Character.prototype.ladderRotate = function () {
  this.rotation = 12;
}

EHDI.game.Character.prototype.isInStartingPos = function () {
  return (this.x == this._characterStartingX);
}

EHDI.game.Character.prototype.getGravity = function () {
  return this._gravity;;
};
